import { useState } from 'react';

import { showAlert } from 'components/shared/Alert/Alert';

const useCopy = ({ isText = true, alert = true } = {}) => {
  const [copyText, setCopyText] = useState(isText ? 'Copy' : '');

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      setCopyText("Couldn't copy");
      if (alert) {
        showAlert({
          title: "Couldn't copy",
          message: 'Clipboard access is blocked in this browser.',
          color: 'danger'
        });
      }
      return false;
    }

    setCopyText('Copied');
    setTimeout(() => setCopyText(isText ? 'Copy' : ''), 2000);
    if (alert) {
      showAlert({
        title: 'Copied to clipboard',
        color: 'success',
        duration: 500
      });
    }
    return true;
  };

  return { copyText, copyToClipboard };
};

export default useCopy;
